export default __webpack_public_path__ + "static/media/collapsible-app-bar-1.bcf59670.png";